export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["网站"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商店ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商店设置"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支付链接"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活跃"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不活跃"])}
}